<div
  class="divide-y divide-slate-100 min-h-[50px]"
>
<div class="p-4 mb-4 bg-gray-50 rounded-lg border border-gray-200">
  <p class="text-sm text-gray-600 italic">
    The list below is for reference only; dynamic instructions are not applied. 
    <span class="text-blue-500 text-sm font-medium w-4" role="button" (click)="editList()">Edit list</span>
  </p>
</div>
  @for (item of displayNames(); track item.id; let i = $index) {
  <div
    class="p-5 group transition-colors relative bg-white"
  >
    <div class="flex items-center gap-4">
    <div class="w-4"></div> 
      <span class="text-slate-400 text-sm font-medium w-4"
        >{{ item.option_key }}
      </span>
      <div
        class="flex-1 flex items-center gap-2"
      >
        @if (item.is_mutually_exclusive) {
        <span class="text-[9px] px-1.5 py-0.5 rounded bg-amber-100 text-amber-400 font-bold uppercase">Exclusive</span>
        } @else if (item.is_open_ended) {
        <span class="text-[9px] px-1.5 py-0.5 rounded bg-blue-100 text-blue-400 font-bold uppercase">Open Ended</span>
        } 
        <input
          type="text"
          [value]="item.option_display"
          readonly
          class="flex-1 bg-transparent text-slate-400 border-none focus:ring-0 p-0 text-base outline-none py-3 min-h-[48px]"
        />
      </div>
    </div>
  </div>
  } @empty {
  <div class="p-10 text-center text-slate-400 text-sm italic">
    The parent list currently has no options to preview
  </div>
  }
</div>
